import React from 'react';

const Card = ({ image, title, description }) => {
    return (
        <div className="bg-[#2d3748] rounded-xl shadow-md overflow-hidden">
            <img src={image} alt={title} className="w-full h-48 object-cover rounded-t-lg" />
            <div className="p-4">
                <h3 className="text-xl font-semibold mb-2 text-[#e2e8f0]">{title}</h3>
                <p className="text-gray-400 text-sm">{description}</p>
            </div>
        </div>
    );
};

export default Card;